import type { Shadows } from '@mui/material/styles';

import { shadows } from 'src/design-tokens/primitives';

const LADDER_LENGTH = 25;
const LAST_SMALL_ELEVATION = 4;
const LAST_MEDIUM_ELEVATION = 12;

const shadowForElevation = (elevation: number) => {
  if (elevation === 0) return 'none';
  if (elevation === 1) return shadows.xsmall;
  if (elevation <= LAST_SMALL_ELEVATION) return shadows.small;
  if (elevation <= LAST_MEDIUM_ELEVATION) return shadows.medium;

  return shadows.large;
};

export const muiShadows = Array.from(
  { length: LADDER_LENGTH },
  (_, elevation) => shadowForElevation(elevation)
) as Shadows;
